export default __webpack_public_path__ + "static/media/Sanctimonious Helm.e21d7eb1.jpg";